import { render, staticRenderFns } from "./ListPc.vue?vue&type=template&id=1b2d72c4&scoped=true"
import script from "./ListPc.vue?vue&type=script&lang=js"
export * from "./ListPc.vue?vue&type=script&lang=js"
import style0 from "./ListPc.vue?vue&type=style&index=0&id=1b2d72c4&prod&scoped=true&lang=less"
import style1 from "./ListPc.vue?vue&type=style&index=1&id=1b2d72c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d72c4",
  null
  
)

export default component.exports